import { DARK, LEFT, LIGHT } from "../core/constants";

import Box from "./Box";
import CloseButton from "./CloseButton";
import ExpandableMenuItem from "./ExpandableMenuItem";
import Line from "./Line";
import MenuItem from "./MenuItem";
import SideMenu from "./SideMenu";
import { useAppContext } from "./AppContext";

function MobBrandMenu({ navItems }) {
  const { mobBrandMenuOpen, setMobBrandMenuOpen } = useAppContext();

  return (
    <SideMenu
      open={mobBrandMenuOpen}
      setOpen={setMobBrandMenuOpen}
      startPos={LEFT}
      theme={DARK}
    >
      <Box
        bg="black"
        position="sticky"
        top={0}
        px={25}
        pt={48}
        display="flex"
        justifyContent="flex-end"
      >
        <CloseButton
          theme={LIGHT}
          onClick={() => {
            setMobBrandMenuOpen(false);
          }}
        />
      </Box>
      <Box pt={40} px={25} color="white">
        {navItems.map((item) => {
          if (item.children.length) {
            return (
              <Box key={item.slug}>
                <Line theme={LIGHT} />
                <ExpandableMenuItem item={item} color="white" />
              </Box>
            );
          } else {
            return (
              <Box key={item.slug}>
                <Line theme={LIGHT} />
                <MenuItem name={item.name} slug={item.slug} color="white" />
              </Box>
            );
          }
        })}
        <Line theme={LIGHT} />
      </Box>
    </SideMenu>
  );
}

export default MobBrandMenu;
